import { Button, ListItemButton, ListItemText, Stack } from '@mui/material';
import React from 'react';
import { FinsightEntityField } from 'shared';

import { InputArea } from './InputArea';

interface PropertiesManagerProps {
  field: FinsightEntityField['schema'];
  setField: (field: FinsightEntityField['schema']) => void;
  onPropertyClick: (index: number) => void;
  onDeleteProperty: (index: number) => void;
  disabled?: boolean;
}

export function PropertiesManager({
  field,
  setField,
  onPropertyClick,
  onDeleteProperty,
  disabled = false,
}: PropertiesManagerProps) {
  return (
    <InputArea
      name="Properties"
      description={`Properties are only used when the field type is Object or Enum.
- Object: Properties is an object with keys for each property name and a field definition as the value.
- Enum: Properties is an array of objects with field definitions. Each object should have a name and type field.`}
    >
      {Array.isArray(field.properties) &&
        field.properties.map((x, i) => (
          <Stack key={i} direction="row" alignItems="center" spacing={1}>
            <ListItemButton
              onClick={() => onPropertyClick(i)}
              sx={{ flexGrow: 1 }}
              disabled={disabled}
            >
              <ListItemText primary={x.name} secondary={x.type} />
            </ListItemButton>
            <Button
              size="small"
              color="error"
              variant="outlined"
              onClick={() => onDeleteProperty(i)}
              disabled={disabled}
            >
              Delete
            </Button>
          </Stack>
        ))}
      <Button
        onClick={() => {
          setField({
            ...field,
            properties: [
              ...(Array.isArray(field.properties) ? field.properties : []),
              { type: 'string' },
            ],
          });
        }}
        disabled={disabled}
      >
        Add New Property
      </Button>
    </InputArea>
  );
}
